import {FlightModeSound} from "./FlightModeSound";

export interface WinSoundConfig {
    start:string;
    sound:string;
    end:string;
}

export class WinConfigBased {
    name:string;
    fromRatio:number;
    toRatio:number;
    duration:number;
    sound:WinSoundConfig;
}

export class WinConfigUtilBased {

    public static TINY = {
        name: "TINY",
        fromRatio: 0,
        toRatio: 1,
        duration: 0,
        sound: {
            start : FlightModeSound.WIN_TINY_START,
            sound : FlightModeSound.WIN_TINY,
            end   : FlightModeSound.WIN_TINY_END
        }
    }
    public static SMALL = {
        name: "SMALL",
        fromRatio: 1,
        toRatio: 3,
        duration: 0,
        sound: {
            start : FlightModeSound.WIN_SMALL_START,
            sound : FlightModeSound.WIN_SMALL,
            end   : FlightModeSound.WIN_SMALL_END
        }
    }
    public static MEDIUM = {
        name: "MEDIUM",
        fromRatio: 3,
        toRatio: 5,
        duration: 0.5,
        sound: {
            start : FlightModeSound.WIN_MEDIUM_START,
            sound : FlightModeSound.WIN_MEDIUM,
            end   : FlightModeSound.WIN_MEDIUM_END
        }
    }
    public static LARGE = {
        name: "LARGE",
        fromRatio: 5,
        toRatio: 15,
        duration: 0.75,
        sound: {
            start : FlightModeSound.WIN_LARGE_START,
            sound : FlightModeSound.WIN_LARGE,
            end   : FlightModeSound.WIN_LARGE_END
        }
    }

    //25x, 50x, 100x, 250x, 250x+
    // big wins have empty sound configs because big win sounds are handled in a different way than regular wins
    public static BIG_1 = {
        name: "BIG_1",
        fromRatio: 0,
        toRatio: 25,
        duration: 2.743,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_2 = {
        name: "BIG_2",
        fromRatio: 25,
        toRatio: 50,
        duration: 2.743,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_3 = {
        name: "BIG_3",
        fromRatio: 50,
        toRatio: 100,
        duration: 2.743,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_4 = {
        name: "BIG_4",
        fromRatio: 100,
        toRatio: 250,
        duration: 2.743,
        sound: {start: "", sound: "", end: ""}
    }
    public static BIG_5 = {
        name: "BIG_5",
        fromRatio: 250,
        toRatio: Number.MAX_VALUE,
        duration: 5.486,
        sound: {start: "", sound: "", end: ""}
    }

    public static normalLevels:WinConfigBased[] = [
        WinConfigUtilBased.TINY,
        WinConfigUtilBased.SMALL,
        WinConfigUtilBased.MEDIUM,
        WinConfigUtilBased.LARGE,
    ];

    public static bigLevels:WinConfigBased[] = [
        WinConfigUtilBased.BIG_1,
        WinConfigUtilBased.BIG_2,
        WinConfigUtilBased.BIG_3,
        WinConfigUtilBased.BIG_4,
        WinConfigUtilBased.BIG_5
    ];

    public static bigWinThresholds:{[name:string]:number} = {
        FREESPIN_3_SCATTERS: 40,
        FREESPIN_4_SCATTERS: 100,
        FREESPIN_5_SCATTERS: 200,
        LUCKY_DRAW: 100,
        BOOSTED_BET_STATE_268: 90,
        BOOSTED_BET_STATE_911: 270,
        GOD_MODE: 911,
    }
}

